import { shape, string } from "prop-types";
import breakpoints from "../../common/breakpoints.js";
import * as R from "ramda";

const source = shape({
  x1: string,
  x2: string,
});

const propTypes = {
  sources: shape({
    large: source,
    medium: source,
    small: source,
  }),
  className: string,
  alt: string,
};

const Picture = (props) => {
  const {
    sources: { large, medium, small },
    className,
    alt,
    ...otherProps
  } = props;

  const srcSet = (source) =>
    R.compose(
      R.join(", "),
      R.reject(R.isNil),
    )([
      source.x1 ? `${source.x1} 1x` : undefined,
      source.x2 ? `${source.x2} 2x` : undefined,
    ]);

  return (
    <picture className={className}>
      <source
        media={`(min-width: ${breakpoints["bp-large"]})`}
        srcSet={srcSet(large)}
      />
      <source
        media={`(min-width: ${breakpoints["bp-medium"]})`}
        srcSet={srcSet(medium)}
      />
      <img alt={alt} {...otherProps} srcSet={srcSet(small)} />
    </picture>
  );
};

Picture.propTypes = propTypes;

export default Picture;

// helper function for stories
export const makeSources = (src) => ({
  large: {
    x1: src,
  },
  medium: {
    x1: src,
  },
  small: {
    x1: src,
  },
});
